// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_RmV","cls2":"common-cls2_P-q common-cls1_RmV"};